import http from '../../http'
import CompanyItemsAPI from '../../items/companies_itemsAPI';

const API_URL = "companies"

/**
 * @class ScoreAPI
 * @description This class is used to call the API for the Score Company service.
 * @exports ScoreAPI - The ScoreAPI class.
 */
class ScoreAPI {

  /**
   * This method is used to save the score of a company and not repeat the same procedure.
   * @param {Number} companyID Company ID
   * @param {Number} itemID Item ID
   * @returns {JSON} Response from the server
   */
  async saveSecureScore(companyID, itemID) {

    const company = JSON.parse(localStorage.getItem('company')) || null;

    if (!company) {
      console.log('The company is required')
      return
    }

    const data = {
      companies_id: companyID,
      items_id: itemID,
      company_classification_id: company.company_classification_id
    }

    const response = await http(`${API_URL}/puntationnorepeat`, 'POST', data)
    return response
  }

  /**
   * This method is used to save the score of a company for the first time.
   * Is possible to save data for multiple times.
   * @param {Number} companyID Company ID
   * @param {Number} itemID Item ID
   * @returns {JSON} Response from the server
   */
  async saveScore(companyID, itemID) {
    const response = await http(`${API_URL}/puntation`, 'POST', {
      companies_id: companyID,
      items_id: itemID
    })
    return response
  }

  /**
   * This method apply the item to the company if the item don't exists for the company.
   * @param {Number} companyID CompanyID
   * @param {Number} itemID Item ID
   * @returns {JSON} Response from the server
   */
  async applyItem(companyID, itemID) {
    try {

      const item = await CompanyItemsAPI.getStatus(companyID, itemID)

      if (item.id) {
        return `Item ${itemID} for the company ${companyID} exists`
      }

      return this.saveSecureScore(companyID, itemID)

    } catch (error) {
      return `Error: ${error}`
    }

  }

}

export default new ScoreAPI()